/* eslint-disable @typescript-eslint/no-explicit-any */
import { Label, setColorTheme } from '@facephi/ui-react';
import styled from 'styled-components';

export const BannerStyles = styled(Label)<{ $margin?: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 0.8rem;
  height: 3.2rem;
  background: ${setColorTheme('white')};
  border-radius: 0.6rem;
  width: 100%;
  text-transform: uppercase;
  margin: ${({ $margin }) => ($margin ? '1.2rem 0 1.6rem' : '0')};
` as any;
